import { Link, useLocation, useParams } from "react-router-dom";
import { IconNavbarHomeActive } from "../../assets/icons/IconNavbarHomeActive";
import { Breadcrumbs, Container, Contents } from "./styles";
import { contentsLink } from "../../components/LpFooter";
import BlogCard from "../../components/BlogCard";
import { useEffect, useState } from "react";

export default function BlogItemPage() {
  const location = useLocation();
  const { slug } = useParams();
  const { content } = location.state || {};

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (content) {
      setItem(content);
      setLoading(false);
    } else if (slug) {
      fetch(`https://imbilcrbn8.execute-api.us-east-1.amazonaws.com/Prod/api/v1/blog/slug/${slug}`)
        .then(res => res.json())
        .then(data => {
          setItem(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [content, slug]);

  return (
    <Container>
      <Breadcrumbs>
        <IconNavbarHomeActive />
        <span>/</span>
        <Link to={contentsLink}>Blog</Link>
        <span>/</span>
        <Link to={`${contentsLink}/${slug}`}>{slug}</Link>
      </Breadcrumbs>

      <Contents>
        {loading || !item ? (
          <div>Carregando...</div>
        ) : (
          <BlogCard
            content={{
              postId: item.postId,
              slug: item.slug,
              imageUrl: item.imageUrl,
              createdAt: item.createdAt,
              title: item.title,
              description: item.description,
              height: 'auto',
            }}
          />
        )}
      </Contents>
    </Container>
  );
}
